if (!customElements.get('swiper-scroll-fix')) {
  class SwiperScrollFix extends HTMLElement {
    constructor() {
      super();
      this.shadow = this.querySelector('swiper-container').shadowRoot;
      this.updateShadowContent();
    }

    updateShadowContent() {
      this.shadow.querySelector('.swiper').style.position = 'unset';
    }
  }
  customElements.define('swiper-scroll-fix', SwiperScrollFix);
}
